import React from "react";

export default function ReportDeleteModal({
    isOpen,
    report,
    loading,
    onClose,
    onConfirm,
}) {
    if (!isOpen || !report) return null;

    return (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 px-4">
            <div className="w-full max-w-md rounded-[28px] bg-white shadow-xl dark:bg-slate-950">
                <div className="border-b border-slate-200 px-6 py-4 dark:border-slate-800">
                    <h3 className="text-base font-semibold text-slate-900 dark:text-slate-100">
                        Eliminar informe
                    </h3>
                </div>
                <div className="space-y-3 px-6 py-4">
                    <p className="text-sm text-slate-700 dark:text-slate-300">
                        Estas seguro que deseas eliminar este informe?
                    </p>
                    <p className="truncate text-sm font-medium text-slate-900 dark:text-slate-100">
                        {report.title}
                    </p>
                </div>
                <div className="grid grid-cols-1 gap-3 border-t border-slate-200 px-6 py-4 dark:border-slate-800 sm:grid-cols-2">
                    <button
                        type="button"
                        onClick={onClose}
                        className="inline-flex min-h-[44px] items-center justify-center rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        className="inline-flex min-h-[44px] items-center justify-center rounded-xl bg-red-600 px-4 py-2 text-sm font-semibold text-white disabled:cursor-wait"
                        disabled={loading}
                    >
                        {loading ? "Eliminando..." : "Eliminar"}
                    </button>
                </div>
            </div>
        </div>
    );
}
